// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2tXDx","Link":"Footer_Link__3i5Wr"};